import { fetchWithoutToken } from '../../../utils/helpers/fetcher';

const useRecoverPassword = () => {
  const sendRecoverPasswordEmail = async ({ email, lang }) => {
    const currentUrl = window.location.origin;
    const link = `${currentUrl}/recover?recoverytoken=[TOKEN]&lang=[LANG]`;

    return fetchWithoutToken({
      path: 'front/recover-account',
      method: 'POST',
      data: {
        email,
        link,
        lang
      },
      disableCatchHandling: true
    });
  };

  const sendNewPassword = async ({ token, new_password }) => {
    return fetchWithoutToken({
      path: 'front/recover-account-password',
      method: 'POST',
      data: {
        token,
        new_password
      }
    });
  };

  return {
    sendRecoverPasswordEmail,
    sendNewPassword
  };
};

export default useRecoverPassword;
